import React from 'react'

const SearchInput = React.forwardRef((props, ref) => (
  <label className='league-search'>
    <span className='fa fa-search' />
    <input className='search-input' placeholder='Search game or league' {...props} ref={ref} />
  </label>
))

export default SearchInput
